$(function() {
  // *** VIDEO INTO GALLERY INTEGRATION ***
  // Remove Embedded iframes from product description,
  // Create video thumbnail based off of default product image,
  // Add everything to gallery at top
  $('.product-details-list iframe, .product_wrap #product_description iframe').each(function (index, value){

    $(this).wrap('<a class="video-thumb" href="#"></a>');
    $('.video-thumb').append('<span class="cover"><span class="icon"><span class="play-btn"></span></span></span>');
    var firstSrcI = $('#elevatezoom_big').attr('src');
    var firstAltI = $('#elevatezoom_big').attr('alt');

    if ($('#elevatezoom_gallery').length === 0) {
      var firstImgI = '<a class="first-image-thumb" data-image="' + firstSrcI + '"	data-zoom-image="' + firstSrcI + '" style="float: left; list-style: none; position: relative; width: 103px; margin-right: 12px;"><img src="' + firstSrcI + '" alt="' + firstAltI + '" /></a><a class="second-image-thumb video-thumb" data-image="' + firstSrcI + '"	data-zoom-image="' + firstSrcI + '" style="float: left; list-style: none; position: relative; width: 103px; margin-right: 12px;"><img src="' + firstSrcI + '" alt="' + firstAltI + '" /></a>';
      $('.product_images').append('<div class="bx-wrapper" style="max-width: 327px;"><div class="bx-viewport" style="width: 100%; overflow: hidden; position: relative; height: auto;"><div id="elevatezoom_gallery" class="new-gal" style="width: 860%; position: relative; transition-duration: 0s; transform: translate3d(0px, 0px, 0px);"></div></div></div>');
      $('.new-gal').html(firstImgI);
      $(this).clone().appendTo('.video-thumb');
      $('.second-image-thumb').append('<span class="cover"><span class="icon"><span class="play-btn"></span></span></span>');
    } else {
      var iframeVid = $('.video-thumb').html();
      var firstImg = '<a class="video-thumb" href="#"	data-image="' + firstSrcI + '"	data-zoom-image="' + firstSrcI + '" style="float: left; list-style: none; position: relative; width: 103px; margin-right: 12px;"><img src="' + firstSrcI + '" alt="' + firstAltI + '" />' + iframeVid + '</a>';
      $(firstImg).prependTo('#elevatezoom_gallery');
      $('#elevatezoom_gallery a:nth-child(2)').prependTo('#elevatezoom_gallery');
    }
  });

  // Remove any iframe on each thumbnail click
  $('#elevatezoom_gallery a').click(function() {
    $('.zoomWrapper iframe').remove();
    hideIcons();
  });
  // Clone iframe attached to thumbnail into gallery image window
  $('#elevatezoom_gallery a.video-thumb').click(function() {
    $(this).find('iframe').clone().prependTo('.zoomWrapper');
    hideIcons();
  });
  // Hide empty p tags in description
  var strDet = $('.product-details-list p').text();
  if (!strDet.trim()) {
    $(this).hide();
  }
  // Hide empty description boxes (after split)
  var strDesc = $('#product_description').text();
  if (!strDesc.trim()) {
    $('#product_description').hide();
  }

  // Plus/Minus Quantity Buttons
  $('.qty-container').on('click', '.qty-num-change', function() {
    var d = this.id==='qty-minus' ? -1 : 1;
    var $container = $(this).parent();
    var $input = $container.find('input.quantity-input');
    var n = Math.max( $input.attr('min'), parseInt($input.val(), 10) + d);

    if(isNaN(n)) {
      console.log('Not a number...', $input.val(), n);
      return;
    }

    // Update input field with constrained value and trigger change notification
    $input.val( n );
    $container.trigger('change:qty', n);
  });

  // capture +/- changes on cart line item quantities
  $('.cart-line-qty').on('change:qty', function(e, qty){
    var line = $(this).data('line');
    updateQuantity(line, qty);
  });

  // capture manual (text) changes to line item quantities
  $('.quantity-input').on('change', function(){
    var line = this.id.split('_').pop();
      updateQuantity(line, $(this).val());
  });

  // Update the Shopify Cart (in response to quantity change)
  var updateQuantity = function (item_id, qty) {

    // if qty is 0, remove the line item from the DOM
    if(qty==0) {
      // once quantity is 0, item is removed from cart.
      // we can remove the entire line item display
      $('#cart-item__' + item_id).fadeOut();
    }

    // Update the quantity
    Shopify.changeItem(item_id, qty, function (cart) {

      // Share updated cart data with our friends
      Shopify.onCartUpdate(cart);

      _.defer(function() {
          // Render updated total and subtotals on the cart page
          updateCartLineItem(cart, item_id);
      });
    });
  };

  function updateCartLineItem( cart, item_id ) {

    if(!$('body').is('.template-cart')) {
      // this code only runs on the cart page
      return;
    }

    // Reload if cart is now empty
    if(!cart.items || !cart.items.length) {
      $('#cart-total-price').fadeOut();
      window.location.reload();
      return;
    }

    var item = _.find(cart.items, {id: item_id});

    // Re-render Line Price and total price (without reloading)
    $('#line-price__'+item.id).html( money( item.line_price ) );
    $('#cart-total-price').html( money( cart.total_price ) );

  }

  function money( num ) {
    return '$'+(num / 100 ).toFixed(2).replace('.', '.<sup>') + '</sup>';
  }

  function triggerReload() {
      window.location.reload();
  }

  // MOBILE SCRIPTS
  var screenSize = 767; // Set breakpoint here
  $(document).ready(function(){
    mobFunc();

    $(window).resize(function(){
      mobFunc();
    });
  });
  function mobFunc(){
    var screen = $(window);
    if (screen.width() > screenSize) {
      // console.log("not mobile");
    } else {
      //console.log("mobile");
      // $(".zoomWrapper").click(function(e){
      //   e.preventDefault();
      // });
    }
  }

if ($('body').hasClass('template-product')) {
  $('#elevatezoom_big').panzoom({
    contain: 'automatic',
    minScale: 1,
    maxScale: 5,
    increment: 1
  });
  $('#elevatezoom_big').panzoom('disable');

  $('.fa-search-plus').click(function(){
    $(this).hide();
    $('.fa-times').show();
    $('.cover-box').hide();
    $('#elevatezoom_big').panzoom('enable').panzoom('zoom', 1.5);
  });

  $('.fa-times').click(function(){
    $(this).hide();
    $('.fa-search-plus').show();
    $('.cover-box').show();
    $('#elevatezoom_big').panzoom('resetZoom').panzoom('resetPan').panzoom('disable');
  });

}

function hideIcons() {
  // Reset functionality and factor in iFrame prescence
  if ($('.zoomWrapper iframe').length) {
    $('#zoom-start, #zoom-stop').hide();
    $('.cover-box').hide();
  } else {
    $('.cover-box').show();
    $('#zoom-stop').hide();
    $('#zoom-start').show();
    $('#elevatezoom_big').panzoom('resetZoom').panzoom('resetPan').panzoom('disable');
  }
}

  $('.mobile-accordion #chat-widget').click(function(){
    $('#lc_chat_layout').show().toggleClass('lc-collapsed lc-expanded');
  });


  $('.widget_related_products').prepend('<i class="fa fa-chevron-left arrows" aria-hidden="true"></i><i class="fa fa-chevron-right arrows" aria-hidden="true"></i>');

  var scrollWidth = $('.widget_related_products .widget_content').width();
  var scrollDist  = scrollWidth / 2;
  var leftPos;
  $('.fa-chevron-left').click(function(){
    leftPos = $('.widget_related_products .widget_content').scrollLeft();
    $('.widget_related_products .widget_content').animate({scrollLeft: leftPos - scrollDist}, 200);
  });
  $('.fa-chevron-right').click(function(){
    leftPos = $('.widget_related_products .widget_content').scrollLeft();
    $('.widget_related_products .widget_content').animate({scrollLeft: leftPos + scrollDist}, 200);
  });

  if ($('body').hasClass('template-index')) {
    $('.back-btn a').text('SEARCH').addClass('search-btn');
    $('.back-btn a i').hide();
    $('.back-btn a').click(function(e){
      e.preventDefault();
    });
  } else {
    if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) {
      $('.back-btn a').click(function(e){
        e.preventDefault();
        parent.history.back();
        return false;
      });
    } else {
      $('.back-btn a').text('Search').addClass('search-btn');
      $('.back-btn a i').hide();
      $('.back-btn a').click(function(e){
        e.preventDefault();
      });
    }
  }


  // Add to Cart Modal
  // cartDivH();

  var prodImage,
      prodTitle;

  $('#add-to-cart').click(function(e){
    $('#closeModal i').show(); // To address conflicting code in other part of project
    var itemQty = $('#quantity').val();
    if (itemQty > 1) {
      $('.header-text .multiple-items').addClass('visible');
    }
    $('.header-text .item-qty').text(itemQty);

    setTimeout(cartDivH, 300);
  });

  $('.site-dimmer, #closeModal').click(function(){
    if($('.site-dimmer').hasClass('dimmed')) {
      $('.site-dimmer').removeClass('dimmed');
    }
    if($('#cartModal').hasClass('visible')) {
      $('#cartModal').removeClass('visible');
      if ($('body').hasClass('template-collection')) {
        $('#cartModal').removeClass('collection-cart');
      }
    }
  });

  if ($('body').hasClass('template-collection')) {
    colCartAdd();
  }

  function modalH() {
    var winH = $(window).height();
    var modH = $('#cartModal').height();
    if( modH >= winH ) {
      $('#cartModal').addClass('tall-div');
    } else {
      $('#cartModal').removeClass('tall-div');
    }
  }

  function cartDivH() {

    if ($(window).width() >= 992) {
      var cartDiv1 = $('#cartModal .cart-body .left-cart');
      var cartDiv2 = $('#cartModal .cart-body .right-cart');
      var cartDiv2P1 = $('#cartModal .cart-body .right-cart .cart-list').height();
      var cartDiv2P2 = $('#cartModal .cart-body .right-cart .checkout-btns').height();
      var cartDiv1H = cartDiv1.height();
      var cartDiv2H = cartDiv2P1 + cartDiv2P2 + 120;

      // console.log(cartDiv1H);
      // console.log(cartDiv2P1);
      // console.log(cartDiv2P2);

      if (cartDiv1H > cartDiv2H) {
        cartDiv2.css('height', cartDiv1H);
      } else if (cartDiv1H < cartDiv2H) {
        cartDiv1.css('height', cartDiv2H);
      }
    } else {
      $('#cartModal .row.suggested').detach().appendTo('#cartModal .cart-body .col-lg-6:last-child');
      $("html, body").animate({ scrollTop: 0 }, 300);
    }

    modalH();
  }

  // Fake those stars...
  // function starsss(){
  //   if (!$('.yotpo.bottomLine span').hasClass('yotpo-stars')) {
  //     $(this).before('<span class="yotpo-stars"><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span></span>');
  //   }
  // }
  // setTimeout(starsss, 5000);

});



function colCartAdd() {
  // console.log('template-collection');
  // var btnID;
  // $('[id^="add-to-cart-"]').click(function(){
  //   btnID = $(this).data('id');
  //   alert(btnID);
  // });

  // $('.product_links form .btn-cart').click(function(){
  //
  //   $(this).addClass('this');

    // $('#closeModal i').show(); // To address conflicting code in other part of project
    // var itemQty = $('#quantity').val();
    // if (itemQty > 1) {
    //   $('.header-text .multiple-items').addClass('visible');
    // }
    // $('.header-text .item-qty').text(itemQty);
    //
    // cartDivH();


      // prodImage = $(this).closest('.product').find('div .product_img');
      // prodTitle = $(this).closest('.product').find('div .product_info .product_name');
      // console.log(prodTitle);


  // });
}
